<template>
    <table class="checkout__totals">
        <thead class="checkout__totals-header">
            <tr>
                <th>Summary</th>
                <th class="text-right">Amount</th>
				<th>Line Items</th>
            </tr>
        </thead>
        <tbody class="checkout__totals-products">
			<tr>
                <td><strong>Ordered:</strong></td>
                <td class='notranslate'>{{toUSD(totals[0].subtotal)}}</td>
				<td>{{cartquantity}}</td>
            </tr>
            <tr v-if="totals[0].coretotal > 0">
                <td><strong>Core:</strong></td>
                <td class='notranslate'>{{toUSD(totals[0].coretotal)}}</td>
				<td><span>{{core_items}}</span></td>
            </tr>
            <tr>
                <td><strong>Shipping & Handling:</strong></td>
                <td class='notranslate'>{{toUSD(totals[0].shippingtotal)}}</td>
                <td> </td>
            </tr>
            <tr>
                <td><div class="block-space--layout--divider-5"></div></td>
                <td> </td>
                <td> </td>
            </tr>
            <tr v-for="promo in promos_format" :key="promo.code">
                <td>
                    <strong>{{promo.title}}:</strong>
                    <br><div class="text-promotion-applied-total">{{promo.desc}}</div>
                </td>
                <td class='notranslate'>- {{toUSD(promo.amnt_dc)}}</td>
                <td> </td>
            </tr>
        </tbody>
        <tfoot class="checkout__totals-footer">
            <tr>
                <th>Total</th>												
                <th class='notranslate'>{{toUSD(totals[0].ordertotal)}}</th>
				<th></th>
            </tr>
        </tfoot>
    </table>
    <div class="block-space--layout--divider-15"></div>
    <!-- <div class="block-space--layout--divider-xs"></div> -->
    <!-- <h5 class="card-title">Backorder Summary</h5>									
    <table class="checkout__totals">
        <thead class="checkout__totals-header">
            <tr>
                <th>Summary</th>
                <th>Amount</th>
                <th>Line Items</th>
            </tr>
        </thead>
        <tbody class="checkout__totals-products">											                                          
            <tr>
                <td><strong>Backordered:</strong></td>
                <td class="notranslate">{{toUSD(totals[0].backordered_total)}}</td>
                <td>{{boquantity}}</td>
            </tr>
        </tbody>
    </table> -->
</template>

<style scoped>
    .checkout__totals-products tr td.notranslate, .checkout__totals-footer tr th.notranslate{
        text-align: right;
        /* padding-right: 20px; */
    }
</style>

<script>
import { mapGetters } from 'vuex';
import Price from '../../../mixins/price.js';

export default {
    data() {
        return {
            // ordered_price   : 319.99,
            ordered_items   : 0,
            // shipping_price  : 0,
            shipping_items  : 0,
            // backordered_price: 0,
            backordered_items: 0,
            // core_prices     : 92.00,
            core_items      : 0,
            // shipping_hand   : 35.00,
            
            // grandtotal      : 800.32,
        };
    },
    mixins: [Price],
    computed: {
        cartquantity() {
            let totalquantity = 0;
            for (let x in this.cart) {
                if(this.cart[x].backorder != true)
                    totalquantity += parseInt(this.cart[x].quantity);
            }

            this.kits.forEach(kit => {
                kit.kit_items.forEach(ki => {
                    totalquantity += ki.quantity;
                });
            });

            return totalquantity;
        },
        boquantity() {
            let totalquantity = 0;
            for (let x in this.cart) {
                if(this.cart[x].backorder)
                    totalquantity += parseInt(this.cart[x].quantity);
            }
            return totalquantity;
        },
        ...mapGetters(['userIsAuthenticated']),
        ...mapGetters("cart", [
            "cart",
            "totals",
            "promo_code",
            'kits'
        ]),

        promos_format() {
            const promos = [];
            
            this.promo_code.forEach(p => {
                p.title = 'Promotional Discount';

                if(p.to_item != ""){
                    p.title = 'Promotional Item Discount';
                }

                if(p.to_sag != ""){
                    p.title = 'Promotional Sales Category Discount';
                }
                promos.push(p);
            });

            return promos;
        }
    },

    created() {
        // console.table(this.totals);
    }
}
</script>